import DriversAdapter from '../clients/DriversAdapter'
import { DriverTypes, UserOs } from '../store/Constants'

/**
 * Attempt to open download software driver for a given SKU.
 * Behaviour:
 *  - If migrationFlag === true: use 123 API flow (cache + fetchBasicDrivers) (new behaviour)
 *  - Else: fallback to legacy SWLS driver preference list via swlsClient.getDriverDownloadUrl
 * Preference order for fallback:
 *  - Windows: win_sw_setup_integrated -> win_sw_setup -> fullkarnak
 *  - Mac: mac_sw_setup
 * Returns true if navigation triggered, false otherwise.
 */
const openSkuSoftware = async ({
  sku,
  getStoreData,
  os,
  migrationFlag,
  pswApiClientId,
  pswApiUrl
} = {}) => {
  if (!sku || !os) return false

  const driversAdapter = new DriversAdapter(
    undefined,
    pswApiClientId,
    pswApiUrl
  )

  // New 123 migration path
  if (migrationFlag === true) {
    const cached = getStoreData && getStoreData('123SoftwareType')
    if (cached && cached.sku === sku && cached.softwareUrl) {
      window.location.href = cached.softwareUrl
      return true
    }
    const drivers = await driversAdapter.fetchBasicDrivers({
      sku,
      os
    })
    const driverUrl = drivers?.data?.softwareUrl
    if (driverUrl) {
      window.location.href = driverUrl
      return true
    }
    return false
  }

  // Fallback legacy behaviour using SWLS
  let driverTypePreference = []
  const normalizedOs = os.toLowerCase()
  if (normalizedOs.includes(UserOs.windows)) {
    driverTypePreference = [
      DriverTypes.win_sw_setup_integrated,
      DriverTypes.win_sw_setup,
      DriverTypes.fullkarnak
    ]
  } else if (normalizedOs === UserOs.mac) {
    driverTypePreference = [DriverTypes.mac_sw_setup]
  }

  if (!driverTypePreference.length) return false
  try {
    const url = await driversAdapter.getDriverDownloadUrl(
      sku,
      driverTypePreference
    )
    if (url) {
      window.location.href = url
      return true
    }
  } catch (e) {
    console.error('Fallback SWLS driver resolution failed', e)
  }
  return false
}

export default openSkuSoftware
